export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <span className="text-xs font-semibold text-primary-500 uppercase tracking-wider">📬 CONTACT</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-2">联系我们</h2>
            <p className="text-sm text-foreground-500 mt-1">商务合作、版权投诉、原创投稿，我们随时倾听</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-background-100 rounded-2xl p-6 text-center hover:bg-background-200/60 transition-colors duration-200">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-xl bg-primary-100 text-primary-600">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">商务合作</h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">广告投放 · 品牌联名 · 渠道合作</p>
              <span className="text-xs font-medium text-primary-500">business@manmancomic.com</span>
            </div>

            <div className="bg-background-100 rounded-2xl p-6 text-center hover:bg-background-200/60 transition-colors duration-200">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-xl bg-accent-100 text-accent-600">
                <i className="ri-pencil-ruler-2-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">原创投稿</h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">漫画作者入驻 · 作品上传 · 流量扶持</p>
              <span className="text-xs font-medium text-accent-500">submit@manmancomic.com</span>
            </div>

            <div className="bg-background-100 rounded-2xl p-6 text-center hover:bg-background-200/60 transition-colors duration-200">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-xl bg-secondary-100 text-secondary-700">
                <i className="ri-error-warning-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">版权投诉</h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">侵权举报 · 内容下架 · 权利声明</p>
              <span className="text-xs font-medium text-secondary-600">copyright@manmancomic.com</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}